var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"july_box"},[_c('img',{staticClass:"btn_hover ljcz_btn",attrs:{"src":"/activity/july/img/btn.png"},on:{"click":_vm.toRecharge}})])}
var staticRenderFns = []

export { render, staticRenderFns }